import { Action } from "redux";
import { ThunkAction } from "redux-thunk";
import { AppState } from "..";
import { AppStorage } from "../../common/app-storage";
import { BlueMediaService } from "../../service/bm-service";
import settingsService from "../../service/settings-service";
import {
  GET_BM_BANKS,
  PREPARE_APP_REQUEST,
} from "../actions/application-actions";
import { CONSENT_FETCHED } from "../actions/consent-action";

export const prepareApplication =
  (amount: number, billingCompany : string): ThunkAction<void, AppState, unknown, Action<any>> =>
  async (dispatch) => {
    const storege = new AppStorage();
    storege.clear();
    await dispatch({
      type: PREPARE_APP_REQUEST,
    });
    const consents = await settingsService.getConsents();
    await dispatch({
      type: CONSENT_FETCHED,
      payload: consents
    });
    await dispatch({
      type: CONSENT_FETCHED,
      payload: consents
    });
  };

export const getBanks =
  (): ThunkAction<void, AppState, unknown, Action<any>> => async (dispatch) => {
    const service = new BlueMediaService();
    service.getBanks().then(async (p) => {
      await dispatch({
        type: GET_BM_BANKS,
        payload: p,
      });
    });
  };
